import styled from 'styled-components';

import InputStyles from 'admin-components/styles/input';

import Label from 'components/ui/Label';
import Select from 'components/ui/Select';
import { Column } from 'components/shared/Layout';
import { ActionButton, ConfirmButton, CancelButton } from 'components/ui/Button';

import { colours } from 'themes/default';

export const Text = styled.p`
  margin: 0 0 10px 0;
`;

export const BookingFee = styled.div`
  display: flex;
  align-items: flex-start;
  margin: 2%;
`;

export const CheckboxWrapper = styled.div`
  display: block;
  margin-right: 16px;
`;

export const BookingFeeBody = styled(Column)`
  padding: 16px;
`;

export const BookingFeeFooter = styled(Column)`
  padding: 20px;
`;

export const ReasonSection = styled.div`
  background-color: rgb(238, 242, 247);
  box-sizing: border-box;
  display: flex;
  width: 100%;
  padding: 30px;
`;

export const ReasonLabel = styled(Label)`
  margin-right: 40px;
  text-transform: none;
`;

export const ReasonSelect = styled(Select)`
  width: 342px;
`;

export const CalculateRefund = styled(ActionButton)`
  margin: 25px 0 0 0;
  padding: 1.25em 2.5em;
`;

export const ConfirmRefund = styled(ConfirmButton)`
  margin: 25px 20px 0 0;
  padding: 1.25em 2.5em;
`;

export const CancelRefund = styled(CancelButton)`
  margin: 25px 0 0 0;
  padding: 1.25em 2.5em;
`;

export const ExplanationLabel = styled(Label)`
  width: 100%;
  text-transform: none;
`;

export const ExplanationTextArea = styled.textarea`
  ${InputStyles}
  width: 100%;
  resize: vertical;
  padding: 0.6em 1.4em 0.5em 0.8em;
  border-color: ${colours.Greyscale.SilverGrey};
`;

export const AmountToBeRefunded = styled.span`
  margin-left: 5px;
  font-size: 21px;
`;
